import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import {
  fetchGroups,
  selectAllGroups,
  updateGroups,
} from "./features/messages/groupsSlice";
import * as signalR from "@microsoft/signalr";
import { toast } from "react-hot-toast";
import { BaseGUrl, GURL, HttpUrl } from "./services/global";
import { getMyPosition } from "./features/position/positionSlice";
import { HomeOutlined, SignalCellularNull } from "@material-ui/icons";
import {
  Button,
  Col,
  ConfigProvider,
  Dropdown,
  FloatButton,
  Grid,
  Input,
  Layout,
  Menu,
  MenuProps,
  notification,
  Popover,
  Row,
  Select,
  Space,
  Tabs,
  TreeSelect,
} from "antd";
import type { NotificationPlacement } from "antd/es/notification/interface";
import Nav3 from "./components/Navs/Nav3";
import TabPane from "antd/es/tabs/TabPane";
import {
  AppstoreOutlined,
  ContainerOutlined,
  DesktopOutlined,
  MailOutlined,
  PieChartOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons/lib/icons";
import DashboardIcon from "./components/icons/Dashboard";
import NoticesIcon from "./components/icons/NoticesIcon";
import ProfileIcon from "./components/icons/ProfileIcon";
import ChatIcon from "./components/icons/ChatIcon";
import {
  GetMyPosition,
  GetPositionByUser,
  GetPositionRoleByPositionIdAndRole,
} from "./services/PositionService";
import Sider from "antd/es/layout/Sider";
import CustomButton from "./components/share/customButton";
import DashboardIconWhite from "./components/icons/DashboardWhite";
import EditIconWhite from "./components/icons/Sider/EditIconWhite";
import NoticeListIconWhite from "./components/icons/Sider/NoticeList";
import ChatWhiteIcon from "./components/icons/Sider/ChatWhite";
import BuildingWhiteIcon from "./components/icons/Sider/BuildingWhite";
import UserWhiteIcon from "./components/icons/Sider/UserWhite";
import { Content, Header } from "antd/es/layout/layout";
import logo from "./assets/logoWhite.png";
import SelectPosition from "./components/Notice/PositionComponents/SelectPosition";
import TedNotificationIcon from "./components/icons/Navbar/TedNotification";
import TedShutDownIcon from "./components/icons/Navbar/TedShutDown";
import { ColorPalette } from "./components/share/color/colorPalette";
import { fetchUserProfile } from "./features/profile/profileSlice";
import { router } from "./routes";
import CompanyIcon from "./components/icons/NoticeCard/CompanyIcon";
import TedFilterIcon from "./components/icons/TedFilterIcon";
import {
  AddFilter,
  GetFilterDetailsByFilterId,
  GetFiltersByUserIdAndRoute,
} from "./services/FilterService";
import convertToFlatTreeSelectData from "./helpers/Convertors/ConvertToFlatTree";
const { useBreakpoint } = Grid;
function App() {
  const screens = useBreakpoint();
  const dispatch = useDispatch<any>();
  const groupList = useSelector(selectAllGroups);
  const myPositions = useSelector(getMyPosition);
  const [positionId, setPositionId] = useState(null);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  const [noticeFilterPopoverVisible, setNoticeFilterPopoverVisible] =
    useState(false);

  const [api, contextHolder] = notification.useNotification();

  const close = () => {
    // console.log(
    //   "Notification was closed. Either the close button was clicked or duration time elapsed."
    // );
  };
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const applyFilters = (filters: Record<string, string | undefined>) => {
    const updatedParams = new URLSearchParams(searchParams);

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        updatedParams.set(key, value);
      } else {
        updatedParams.delete(key);
      }
    });

    navigate(`?${updatedParams.toString()}`);
  };
  const [currentURL, setCurrentURL] = useState<string>(location.pathname);

  //start Notice Filter
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [getFilterName, setFilterName] = useState("");

  const [getTitleFilter, setTitleFilter] = useState("");
  const [getNoticeDescriptionFilter, setNoticeDescriptionFilter] = useState("");

  //end Notice Filter
  const [getCompanyFilter, setCompanyFilter] = useState("");
  const [getContactFilter, setContactFilter] = useState("");
  const [getDescriptionFilter, setDescriptionFilter] = useState("");
  const [getCompanyContactFilter, setCompanyContactFilter] = useState("");
  const [getInvitationStatusFilter, setInvitationStatusFilter] = useState("");
  const [getMenuKey, setMenuKey] = useState(["2"]);

  const [pageWidth, setPageWidth] = useState<number>(window.innerWidth);
  const handleResize = () => {
    setPageWidth(window.innerWidth);
    setScreenHeight(window.innerHeight);
  };
  const Exit = () => {
    localStorage.removeItem("token");
    dispatch(fetchUserProfile());
    navigate("/login");
  };

  useEffect(() => {
    // Update state whenever the URL changes
    setCurrentURL(location.pathname);
    console.log("URL changed xd to:", location.pathname.toLowerCase());

    if (location.pathname.toLowerCase().includes("/maindashboard")) {
      setMenuKey(["1"]);
      console.log("changed", 1);
    } else if (location.pathname === "/") {
      setMenuKey(["2"]);
      console.log(2);
    } else if (location.pathname.toLowerCase().includes("/dashboard")) {
      setMenuKey(["3"]);
      console.log(3);
    } else if (location.pathname.toLowerCase().includes("/chat")) {
      setMenuKey(["4"]);
      console.log(4);
    } else if (location.pathname.toLowerCase().includes("/companyinfo")) {
      setMenuKey(["6"]);
      console.log(6);
    } else if (
      location.pathname.toLowerCase().includes("/collabratingcompanies")
    ) {
      setMenuKey(["7"]);
      console.log(7);
    } else if (
      location.pathname.toLowerCase().includes("/acceleratormanagement")
    ) {
      setMenuKey(["11"]);
      console.log(11);
    } else if (location.pathname.toLowerCase().includes("/profile")) {
      setMenuKey(["13"]);
      console.log(13);
    }

    if (location.pathname.toLocaleLowerCase().includes("notice")) {
      GetFiltersByUserIdAndRoute("notice").then((p) => {
        // console.log("savedFilters", p.data.data);
        setSavedFiltersTree(convertToFlatTreeSelectData(p?.data?.data));
        setSavedFilters(p?.data?.data);
      });
    }
    if (
      location.pathname.toLocaleLowerCase().includes("collabratingcompanies")
    ) {
      GetFiltersByUserIdAndRoute("collabratingcompanies").then((p) => {
        // console.log("savedFilters", p.data.data);
        setSavedFiltersTree(convertToFlatTreeSelectData(p?.data?.data));
        setSavedFilters(p?.data?.data);
      });
    }
  }, [location]);
  const openNotification = (msg: any, placement: NotificationPlacement) => {
    const key = `open${Date.now()}`;
    const btn = (
      <Space>
        <Button
          className="iran"
          type="link"
          size="small"
          onClick={() => api.destroy()}
        >
          رد کردن
        </Button>
        <Button
          className="iran"
          type="primary"
          size="small"
          onClick={() => {
            navigate("/Manage/Notifications");
            api.destroy();
          }}
        >
          مشاهده
        </Button>
      </Space>
    );
    api.info({
      message: "پیام",
      description: msg,
      placement,
      btn,
      key,
      className: "iran",
      onClose: close,
    });
  };
  const [CreateAdv, setCreateAdv] = React.useState(false);

  const [getSavedFilters, setSavedFilters] = useState<any>([]);

  const [getSavedFiltersTree, setSavedFiltersTree] = useState<
    MenuProps["items"]
  >([]);

  const [getSelectedFilter, setSelectedFilter] = useState<any>();

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    console.log("click", e);
  };

  const handleMenuClickInvitationFiletr: MenuProps["onClick"] = (e) => {
    GetFilterDetailsByFilterId(e.key).then((p) => {
      p?.data?.data.map((item: any) => {
        if (item.key === "InvitationCompanyContact") {
          setCompanyContactFilter(item.value);
        }

        if (item.key === "InvitationContactAddress") {
          setContactFilter(item.value);
        }
        if (item.key === "InvitationDescription") {
          setDescriptionFilter(item.value);
        }
        if (item.key === "InvitationStatus") {
          setInvitationStatusFilter(item.value);
        }
        if (item.key === "InvitationCompanyName") {
          setCompanyFilter(item.value);
        }
      });
      applyFilters({
        CompanyName: p?.data?.data.filter(
          (a: any) => a.key === "InvitationCompanyName"
        )[0].value,
        PhoneNumber: p?.data?.data.filter(
          (a: any) => a.key === "InvitationContactAddress"
        )[0].value,
        Email: p?.data?.data.filter(
          (a: any) => a.key === "InvitationContactAddress"
        )[0].value,
        Description: p?.data?.data.filter(
          (a: any) => a.key === "InvitationDescription"
        )[0].value,
        FullName: p?.data?.data.filter(
          (a: any) => a.key === "InvitationCompanyName"
        )[0].value,
        InvitationStatus: p?.data?.data.filter(
          (a: any) => a.key === "InvitationStatus"
        )[0].value,
      });
    });

    console.log(e.key);
  };

  const handleMenuClick1: MenuProps["onClick"] = (e) => {
    GetFilterDetailsByFilterId(e.key).then((p) => {
      console.log(p);

      p?.data?.data.map((item: any) => {
        if (item.key === "NoticeDescription") {
          setNoticeDescriptionFilter(item.value);
        }

        if (item.key === "NoticeTitle") {
          setTitleFilter(item.value);
        }
      });
      applyFilters({
        Title: p?.data?.data.filter((a: any) => a.key === "NoticeTitle")[0]
          .value,
        Description: p?.data?.data.filter(
          (a: any) => a.key === "NoticeDescription"
        )[0].value,
      });
    });

    console.log(e.key);
  };

  useEffect(() => {
    console.log("getSavedFiltersTree", getSavedFiltersTree);
  }, [getSavedFiltersTree]);

  useEffect(() => {
    //console.log("mesg", currentURL);

    //GetGroupsAsync().then((p) => setUserGroupsInfo(p.data.data));

    GetMyPosition().then((p) => {
      if (p.status === 204) {
        navigate("/Register");
      } else {
        GetPositionRoleByPositionIdAndRole(p?.data?.id, "CreateAdv").then(
          (p) => {
            console.log("sss", p.data.data);

            setCreateAdv(p.data.data);
          }
        );
      }
    });

    //dispatch(fetchGroups());

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    return;
    //console.log("positionId", positionId);
    if (positionId !== null && positionId !== undefined) {
      const connectionNotice = new signalR.HubConnectionBuilder()
        .withUrl(`${BaseGUrl}:808/noticeCategoryNotificationPositionHub`)
        .build();

      connectionNotice.start().then(() => {
        connectionNotice.invoke(
          "SubscribeToProgressUpdates",
          connectionNotice.connectionId,
          positionId
        );

        connectionNotice.on("ProgressUpdate", (messageIdFromSignal: any) => {
          //toast.success(messageIdFromSignal);
          openNotification(messageIdFromSignal, "bottomRight");
          //console.log("up", messageIdFromSignal, "id", messageIdFromSignal);
        });
      });

      return () => {
        connectionNotice.invoke(
          "UnsubscribeFromProgressUpdates",
          connectionNotice.connectionId,
          positionId
        );
        connectionNotice.stop();
      };
    }
  }, [positionId]);
  useEffect(() => {
    console.log("currentURL", currentURL);
  }, [currentURL]);
  useEffect(() => {
    if (myPositions.positions.id !== "") {
      setPositionId(myPositions.positions.id);
    }
  }, [myPositions]);

  //   useEffect(() => {
  //     //	console.log("groupList", groupList);
  // //     if (groupList !== null && groupList !== undefined && true) {
  // //       groupList.map((p: any) => {
  // //         const connection = new signalR.HubConnectionBuilder()
  // //           .withUrl(`https://messaging.x.com/messagingHub`)
  // //           .build();
  // //         //console.log("connectionsig", connection);
  // //
  // //         connection.start().then(() => {
  // //           // console.log("connectionsta", connection);
  // //
  // //           connection.invoke(
  // //             "SubscribeToProgressUpdates",
  // //             connection.connectionId,
  // //             p.id
  // //           );
  // //           connection.on("ProgressUpdate", (messageIdFromSignal: any) => {
  // //             dispatch(
  // //               updateGroups({ messageId: messageIdFromSignal, groupId: p.id })
  // //             );
  // //             //toast.success("پیام جدید");
  // //             //console.log("up", messageId, "id", p.id);
  // //           });
  // //         });
  // //         return () => {
  // //           connection.invoke(
  // //             "UnsubscribeFromProgressUpdates",
  // //             connection.connectionId,
  // //             p.id
  // //           );
  // //           connection.stop();
  // //         };
  // //       });
  // //     }
  //   }, [groupList]);

  const siderStyle: React.CSSProperties = {
    position: "fixed",
    textAlign: "center",
    backgroundColor: "#1677ff",
    height: "100%",
  };

  const headerStyle: React.CSSProperties = {
    textAlign: "left",

    height: "72px",
    padding: "0px 0px 0px 0px",
    backgroundColor: "white",
    width: "100%",
    position: "fixed",
  };

  const contentStyle: React.CSSProperties = {
    textAlign: "center",

    color: "#fff",
    backgroundColor: "#0958d9",
  };

  type MenuItem = Required<MenuProps>["items"][number];
  const items: MenuItem[] = [
    // {
    //   key: "1",
    //   icon: (
    //     <span className="ml-2">
    //       <DashboardIconWhite />
    //     </span>
    //   ),
    //   label: "داشبورد",
    // },
    {
      key: "2",
      icon: (
        <span className="ml-2">
          <NoticeListIconWhite />
        </span>
      ),
      label: "آگهی ها",
    },
    {
      key: "3",
      icon: (
        <span className="ml-2">
          <EditIconWhite />
        </span>
      ),
      label: "مدیریت آگهی ها",
    },
    {
      key: "4",
      icon: (
        <span className="ml-2">
          <ChatWhiteIcon />
        </span>
      ),
      label: "گفتگو",
    },
    {
      key: "7",
      label: "فروشگاه های همکار",
      icon: (
        <span className="ml-2">
          <BuildingWhiteIcon />
        </span>
      ),
    },

    // {
    //   key: "12",
    //   label: "پروفایل فردی",
    //   icon: (
    //     <span className="ml-2">
    //       <UserWhiteIcon />
    //     </span>
    //   ),
    //   children: [
    //     { key: "13", label: "پروفایل" },
    //     { key: "14", label: "اعلانات" },
    //     { key: "15", label: "تغییر کلمه عبور" },
    //     { key: "16", label: "دعوتنامه های من" },
    //   ],
    // },
  ];

  return (
    <>
      {contextHolder}

      {!screens.xs ? (
        <>
          <Header style={headerStyle}>
            <Row
              style={{
                padding: "0px",
                height: "72px",

                direction: "ltr",
              }}
            >
              {/* <Col
                style={{
                  position: "absolute",
                  right: "20px",
                  zIndex: -10,
                }}>
                <img
                  style={{
                    margin: "auto",
                    width: "102px",
                    height: "55.64px",
                  }}
                  src={logo}
                />
              </Col> */}

              <Col
                onClick={() => Exit()}
                style={{ marginLeft: "10px", cursor: "pointer" }}
              >
                <TedShutDownIcon />
              </Col>
              <Col style={{ marginLeft: "10px" }}>
                <TedNotificationIcon />
              </Col>
              <Col style={{ marginLeft: "25px", direction: "rtl" }}>
                <SelectPosition />
              </Col>
            </Row>
            <Row
              style={{
                height: "70px",
                backgroundColor: "white",
                marginTop: "10px",
                paddingBottom: "30px",
                direction: "ltr",
              }}
            >
              <Col
                style={{
                  float: "right",
                  position: "absolute",
                  right: "210px",
                }}
              >
                {(location.pathname.includes("CollabratingCompanies") &&
                  location.search.includes("2")) ||
                (location.pathname.includes("CollabratingCompanies") &&
                  location.search.includes("1")) ? (
                  <>
                    <h3
                      style={{
                        fontFamily: "YekanBakhVF",
                        fontWeight: "600",
                        fontSize: "32px",
                        lineHeight: "44.8px",

                        color: ColorPalette.gray[950],
                        marginRight: "1rem",
                      }}
                      className="mt-2"
                    >
                      فروشگاه های همکار
                    </h3>
                  </>
                ) : (
                  <></>
                )}
                {location.pathname.includes("CompanyInfo") ? (
                  <>
                    <h3
                      style={{
                        fontFamily: "YekanBakhVF",
                        fontWeight: "600",
                        fontSize: "32px",
                        lineHeight: "44.8px",

                        color: ColorPalette.gray[950],
                        marginRight: "1rem",
                      }}
                      className="mt-2"
                    >
                      پروفایل فروشگاه
                    </h3>
                  </>
                ) : (
                  <></>
                )}
                {location.pathname.includes("UserInfo") ? (
                  <>
                    <h3
                      style={{
                        fontFamily: "YekanBakhVF",
                        fontWeight: "600",
                        fontSize: "32px",
                        lineHeight: "44.8px",

                        color: ColorPalette.gray[950],
                        marginRight: "1rem",
                      }}
                      className="mt-2"
                    >
                      پروفایل فردی
                    </h3>
                  </>
                ) : (
                  <></>
                )}
              </Col>
              <Col
                style={{
                  backgroundColor: "transparent",
                }}
              >
                {location.pathname.includes("CompanyInfo") &&
                location.search.includes("7") ? (
                  <>
                    <CustomButton
                      onClick={() => navigate("/CompanyInfo?tab=7&mode=Add")}
                      customType="Primary"
                      hasTitle
                      customSize="XLarge"
                      style={{ width: "152px", marginLeft: "8px" }}
                    >
                      افزودن آدرس جدید
                    </CustomButton>
                  </>
                ) : (
                  <></>
                )}

                {location.pathname.includes("notice") ||
                location.pathname.includes("/") ? (
                  <>
                    <CustomButton
                      onClick={() => navigate("/ManageNotice")}
                      disabled={!CreateAdv}
                      customType="Primary"
                      hasTitle
                      customSize="XLarge"
                      style={{
                        width: "152px",
                        marginLeft: "8px",
                        display: `${
                          currentURL.includes("/notice") ||
                          currentURL.includes("/")
                            ? ""
                            : "none"
                        }`,
                      }}
                    >
                      ثبت آگهی جدید
                    </CustomButton>
                  </>
                ) : (
                  <></>
                )}

                {location.pathname.includes("CollabratingCompanies") ? (
                  <>
                    <CustomButton
                      onClick={() =>
                        navigate("/CollabratingCompanies?tab=2&mode=Add")
                      }
                      customType="Primary"
                      hasTitle
                      customSize="XLarge"
                      style={{ width: "152px", marginLeft: "8px" }}
                    >
                      دعوتنامه جدید
                    </CustomButton>
                  </>
                ) : (
                  <></>
                )}
              </Col>

              {location.pathname.includes("CollabratingCompanies") &&
              location.search.includes("2") ? (
                <>
                  {" "}
                  <Col
                    style={{
                      backgroundColor: "transparent",
                      display: `${
                        !currentURL.includes("CollabratingCompanies")
                          ? "none"
                          : ""
                      }`,
                    }}
                  >
                    <Popover
                      open={popoverVisible}
                      onOpenChange={(visible) => setPopoverVisible(visible)}
                      content={
                        <>
                          <Row>
                            <Col>
                              <Row className="display-flex align-items-center my-2 mt-2">
                                <Col
                                  className="px-1"
                                  style={{ margin: "auto" }}
                                >
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "314",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      عنوان فروشگاه
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        style={{
                                          width: "314px",
                                          height: "40px",
                                        }}
                                        value={getCompanyFilter}
                                        onChange={(e) => {
                                          setCompanyFilter(e.target.value);
                                        }}
                                        className="p-2"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col
                                  className="px-1"
                                  style={{ margin: "auto" }}
                                >
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "325",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      آدرس تماس
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        style={{
                                          width: "314px",
                                          height: "40px",
                                        }}
                                        value={getContactFilter}
                                        onChange={(e) => {
                                          setContactFilter(e.target.value);
                                        }}
                                        className="p-2"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="display-flex align-items-center my-2 mt-2">
                                <Col
                                  className="px-1"
                                  style={{ margin: "auto" }}
                                >
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "314",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      توضیحات
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        style={{
                                          width: "314px",
                                          height: "40px",
                                        }}
                                        value={getDescriptionFilter}
                                        onChange={(e) => {
                                          setDescriptionFilter(e.target.value);
                                        }}
                                        className="p-2"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col
                                  className="px-1"
                                  style={{ margin: "auto" }}
                                >
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "325",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      نام رابط{" "}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        style={{
                                          width: "314px",
                                          height: "40px",
                                        }}
                                        value={getCompanyContactFilter}
                                        onChange={(e) => {
                                          setCompanyContactFilter(
                                            e.target.value
                                          );
                                        }}
                                        className="p-2"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="display-flex align-items-center my-2 mt-2">
                                <Col
                                  className="px-1"
                                  style={{ margin: "auto" }}
                                >
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "314",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      وضعیت
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Select
                                        showSearch
                                        style={{
                                          width: "314px",
                                          height: "40px",
                                        }}
                                        onChange={(e) =>
                                          setInvitationStatusFilter(e)
                                        }
                                        placeholder="انتخاب وضعیت"
                                        optionFilterProp="label"
                                        filterSort={(optionA, optionB) =>
                                          (optionA?.label ?? "")
                                            .toLowerCase()
                                            .localeCompare(
                                              (
                                                optionB?.label ?? ""
                                              ).toLowerCase()
                                            )
                                        }
                                        options={[
                                          {
                                            value: "",
                                            label: "همه",
                                          },
                                          {
                                            value: "پذیرفته شده",
                                            label: "پذیرفته شده",
                                          },
                                          {
                                            value: "ارسال شده",
                                            label: "ارسال شده",
                                          },
                                        ]}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col
                                  className="px-1"
                                  style={{ margin: "auto" }}
                                >
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "325",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      {/* نام رابط{" "} */}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        disabled
                                        style={{
                                          width: "314px",
                                          height: "40px",
                                        }}
                                        value={getCompanyContactFilter}
                                        onChange={(e) => {
                                          setCompanyContactFilter(
                                            e.target.value
                                          );
                                        }}
                                        className="p-2"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="display-flex align-items-center   mt-4">
                                <Col
                                  style={{ width: "100%", textAlign: "left" }}
                                >
                                  <Popover
                                    content={
                                      <>
                                        <Row>
                                          <Input
                                            style={{
                                              width: "314px",
                                              height: "40px",
                                            }}
                                            value={getFilterName}
                                            onChange={(e) => {
                                              setFilterName(e.target.value);
                                            }}
                                            className="p-2"
                                          />
                                        </Row>
                                        <Row className="mt-2">
                                          <CustomButton
                                            onClick={() =>
                                              AddFilter({
                                                title: getFilterName,
                                                route: "collabratingcompanies",
                                                filterDetails: [
                                                  {
                                                    key: "InvitationCompanyContact",
                                                    value:
                                                      getCompanyContactFilter,
                                                  },
                                                  {
                                                    key: "InvitationContactAddress",
                                                    value: getContactFilter,
                                                  },
                                                  {
                                                    key: "InvitationDescription",
                                                    value: getDescriptionFilter,
                                                  },
                                                  {
                                                    key: "InvitationStatus",
                                                    value:
                                                      getInvitationStatusFilter,
                                                  },
                                                  {
                                                    key: "InvitationCompanyName",
                                                    value: getCompanyFilter,
                                                  },
                                                ],
                                              }).then((p) => {
                                                GetFiltersByUserIdAndRoute(
                                                  "collabratingcompanies"
                                                ).then((p) => {
                                                  setSavedFiltersTree(
                                                    convertToFlatTreeSelectData(
                                                      p?.data?.data
                                                    )
                                                  );
                                                  setSavedFilters(
                                                    p?.data?.data
                                                  );
                                                });
                                                toast.success(
                                                  "فیلتر شما با موفقیت ذخیره شد "
                                                );
                                                setPopoverOpen(false);
                                              })
                                            }
                                            customType="Primary"
                                            hasTitle
                                            customSize="XLarge"
                                            style={{
                                              float: "left",
                                              width: "152px",
                                              marginLeft: "8px",
                                            }}
                                          >
                                            ذخیره فیلتر
                                          </CustomButton>
                                        </Row>
                                      </>
                                    }
                                    title={
                                      <>
                                        <span
                                          style={{
                                            fontFamily: "YekanBakhVF",
                                            fontWeight: "325",
                                            fontSize: "16px",
                                            lineHeight: "28.8px",
                                            color: ColorPalette.gray[950],
                                          }}
                                        >
                                          نامی به این فیلتر اختصاص دهید
                                        </span>
                                      </>
                                    }
                                    trigger="click"
                                    open={popoverOpen}
                                    onOpenChange={setPopoverOpen}
                                  >
                                    <CustomButton
                                      customType="Secondary"
                                      hasTitle
                                      customSize="XLarge"
                                      style={{
                                        width: "152px",
                                        marginLeft: "8px",
                                      }}
                                    >
                                      ذخیره فیلتر
                                    </CustomButton>
                                  </Popover>
                                  <CustomButton
                                    onClick={() => {
                                      applyFilters({
                                        CompanyName: getCompanyFilter,
                                        PhoneNumber: getContactFilter,
                                        Email: getContactFilter,
                                        Description: getDescriptionFilter,
                                        FullName: getCompanyContactFilter,
                                        InvitationStatus:
                                          getInvitationStatusFilter,
                                      });
                                      setPopoverVisible(false);
                                    }}
                                    customType="Primary"
                                    hasTitle
                                    customSize="XLarge"
                                    style={{
                                      width: "152px",
                                      marginLeft: "8px",
                                    }}
                                  >
                                    اعمال فیلتر
                                  </CustomButton>
                                  <CustomButton
                                    onClick={() => {
                                      setCompanyContactFilter("");
                                      setContactFilter("");
                                      setDescriptionFilter("");
                                      setCompanyFilter("");
                                      setInvitationStatusFilter("");
                                      applyFilters({
                                        CompanyName: "",
                                        PhoneNumber: "",
                                        Email: "",
                                        Description: "",
                                        FullName: "",
                                        InvitationStatus: "",
                                      });
                                      setPopoverVisible(false);
                                    }}
                                    customType="Secondary"
                                    hasTitle
                                    customSize="XLarge"
                                    style={{
                                      width: "152px",
                                      marginLeft: "8px",
                                    }}
                                  >
                                    پاک کردن{" "}
                                  </CustomButton>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </>
                      }
                      title=""
                      trigger="click"
                      placement="bottom"
                      style={{ backgroundColor: "#F7F9FD" }}
                    >
                      <Dropdown.Button
                        menu={{
                          items: getSavedFiltersTree,
                          onClick: handleMenuClickInvitationFiletr,
                        }}
                        onClick={() => {
                          setPopoverVisible(true);
                        }}
                        size="large"
                        type="primary"
                        style={{
                          marginTop: "10px",

                          marginLeft: "8px",
                          fontFamily: "YekanBakhVF",
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "YekanBakhVF",
                            fontSize: "16px",
                            fontWeight: 325,
                          }}
                        >
                          فیلتر
                        </span>
                      </Dropdown.Button>
                    </Popover>
                  </Col>
                </>
              ) : (
                <></>
              )}

              {location.pathname.includes("notice") ? (
                <>
                  <Col>
                    <Popover
                      open={noticeFilterPopoverVisible}
                      onOpenChange={(visible) =>
                        setNoticeFilterPopoverVisible(visible)
                      }
                      content={
                        <>
                          <Row>
                            <Col>
                              <Row className="display-flex align-items-center my-2 mt-2">
                                <Col
                                  className="px-1"
                                  style={{ margin: "auto" }}
                                >
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "314",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      عنوان آگهی{" "}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        style={{
                                          width: "314px",
                                          height: "40px",
                                        }}
                                        value={getTitleFilter}
                                        onChange={(e) => {
                                          setTitleFilter(e.target.value);
                                        }}
                                        className="p-2"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col
                                  className="px-1"
                                  style={{ margin: "auto" }}
                                >
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "325",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      توضیحات آگهی
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        style={{
                                          width: "314px",
                                          height: "40px",
                                        }}
                                        value={getNoticeDescriptionFilter}
                                        onChange={(e) => {
                                          setNoticeDescriptionFilter(
                                            e.target.value
                                          );
                                        }}
                                        className="p-2"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="display-flex align-items-center my-2 mt-2">
                                <Col
                                  className="px-1"
                                  style={{ margin: "auto" }}
                                >
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "314",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      رزرو
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        style={{
                                          width: "314px",
                                          height: "40px",
                                        }}
                                        value={""}
                                        onChange={(e) => {
                                          //setDescriptionFilter(e.target.value);
                                        }}
                                        className="p-2"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col
                                  className="px-1"
                                  style={{ margin: "auto" }}
                                >
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "325",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      رزرو
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        style={{
                                          width: "314px",
                                          height: "40px",
                                        }}
                                        value={""}
                                        onChange={(e) => {
                                          //setCompanyContactFilter(e.target.value);
                                        }}
                                        className="p-2"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="display-flex align-items-center   mt-4">
                                <Col
                                  style={{ width: "100%", textAlign: "left" }}
                                >
                                  <Popover
                                    content={
                                      <>
                                        <Row>
                                          <Input
                                            style={{
                                              width: "314px",
                                              height: "40px",
                                            }}
                                            value={getFilterName}
                                            onChange={(e) => {
                                              setFilterName(e.target.value);
                                            }}
                                            className="p-2"
                                          />
                                        </Row>
                                        <Row className="mt-2">
                                          <CustomButton
                                            onClick={() =>
                                              AddFilter({
                                                title: getFilterName,
                                                filterDetails: [
                                                  {
                                                    key: "NoticeDescription",
                                                    value:
                                                      getNoticeDescriptionFilter,
                                                  },
                                                  {
                                                    key: "NoticeTitle",
                                                    value: getTitleFilter,
                                                  },
                                                ],
                                              }).then((p) => {
                                                GetFiltersByUserIdAndRoute(
                                                  "notice"
                                                ).then((p) => {
                                                  setSavedFiltersTree(
                                                    convertToFlatTreeSelectData(
                                                      p?.data?.data
                                                    )
                                                  );
                                                  setSavedFilters(
                                                    p?.data?.data
                                                  );
                                                });
                                                toast.success(
                                                  "فیلتر شما با موفقیت ذخیره شد "
                                                );
                                                setPopoverOpen(false);
                                              })
                                            }
                                            customType="Primary"
                                            hasTitle
                                            customSize="XLarge"
                                            style={{
                                              float: "left",
                                              width: "152px",
                                              marginLeft: "8px",
                                            }}
                                          >
                                            ذخیره فیلتر
                                          </CustomButton>
                                        </Row>
                                      </>
                                    }
                                    title={
                                      <>
                                        <span
                                          style={{
                                            fontFamily: "YekanBakhVF",
                                            fontWeight: "325",
                                            fontSize: "16px",
                                            lineHeight: "28.8px",
                                            color: ColorPalette.gray[950],
                                          }}
                                        >
                                          نامی به این فیلتر اختصاص دهید
                                        </span>
                                      </>
                                    }
                                    trigger="click"
                                    open={popoverOpen}
                                    onOpenChange={setPopoverOpen}
                                  >
                                    <CustomButton
                                      customType="Secondary"
                                      hasTitle
                                      customSize="XLarge"
                                      style={{
                                        width: "152px",
                                        marginLeft: "8px",
                                      }}
                                    >
                                      ذخیره فیلتر
                                    </CustomButton>
                                  </Popover>
                                  <CustomButton
                                    onClick={() => {
                                      applyFilters({
                                        Title: getTitleFilter,
                                        Description: getNoticeDescriptionFilter,
                                      });
                                      setNoticeFilterPopoverVisible(false);
                                    }}
                                    customType="Primary"
                                    hasTitle
                                    customSize="XLarge"
                                    style={{
                                      width: "152px",
                                      marginLeft: "8px",
                                    }}
                                  >
                                    اعمال فیلتر
                                  </CustomButton>
                                  <CustomButton
                                    onClick={() => {
                                      setTitleFilter("");
                                      setNoticeDescriptionFilter("");
                                      applyFilters({
                                        CompanyName: "",
                                      });
                                      setNoticeFilterPopoverVisible(false);
                                    }}
                                    customType="Secondary"
                                    hasTitle
                                    customSize="XLarge"
                                    style={{
                                      width: "152px",
                                      marginLeft: "8px",
                                    }}
                                  >
                                    پاک کردن{" "}
                                  </CustomButton>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </>
                      }
                      title=""
                      trigger="click"
                      placement="bottom"
                      style={{ backgroundColor: "#F7F9FD" }}
                    >
                      <Dropdown.Button
                        menu={{
                          items: getSavedFiltersTree,
                          onClick: handleMenuClick1,
                        }}
                        onClick={() => {
                          setNoticeFilterPopoverVisible(true);
                        }}
                        size="large"
                        type="primary"
                        style={{
                          marginTop: "10px",

                          marginLeft: "8px",
                          fontFamily: "YekanBakhVF",
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "YekanBakhVF",
                            fontSize: "16px",
                            fontWeight: 325,
                          }}
                        >
                          فیلتر
                        </span>
                      </Dropdown.Button>
                    </Popover>
                  </Col>
                </>
              ) : (
                <></>
              )}
            </Row>
          </Header>

          <div style={{ display: "flex", backgroundColor: "#abd5ff33" }}>
            <div>
              <Sider width="210px" style={siderStyle}>
                <ConfigProvider
                  theme={{
                    token: {
                      colorText: "white",
                      colorBgContainer: "transparent",
                    },
                  }}
                >
                  <Row style={{ width: "100%" }}>
                    <Col
                      style={{
                        position: "unset",
                        marginRight: "31px",
                        marginTop: "25px",
                      }}
                    >
                      <img
                        style={{
                          margin: "auto",
                          width: "150px",
                        }}
                        src={logo}
                      />
                    </Col>
                  </Row>
                  <br />
                  <hr style={{ color: "white" }} />
                  <Menu
                    defaultSelectedKeys={getMenuKey}
                    selectedKeys={getMenuKey}
                    mode="inline"
                    style={{
                      marginTop: "70px",
                      backgroundColor: "transparent",
                      fontFamily: "YekanBakhVF",
                      fontWeight: 325,
                      fontSize: "16px",
                      lineHeight: "28.8px",
                      textAlign: "right",
                      width: "211px",
                    }}
                    onSelect={(p) => {
                      switch (p.key) {
                        case "1":
                          navigate("/MainDashboard");
                          break;
                        case "2":
                          navigate("/");
                          break;
                        case "3":
                          navigate("/Dashboard");
                          break;
                        case "4":
                          navigate("/Chat");
                          break;
                        case "6":
                          navigate("/CompanyInfo?tab=1");
                          break;
                        case "7":
                          navigate("/CollabratingCompanies?tab=1");
                          break;
                        case "8":
                          navigate("/PersonnelInvitations");
                          break;
                        case "9":
                          navigate("/CompanyInvitations");
                          break;
                        case "10":
                          navigate("/");
                          break;
                        case "11":
                          navigate("/AcceleratorManagement");
                          break;
                        case "12":
                          navigate("/");
                          break;
                        case "13":
                          navigate("/Profile");
                          break;
                        case "14":
                          navigate("/");
                          break;
                        case "15":
                          navigate("/");
                          break;
                        case "16":
                          navigate("/");
                          break;
                        default:
                          console.log(`Unhandled key: ${p.key}`);
                      }
                    }}
                    theme={"light"}
                    items={items}
                  />

                  <Row
                    style={{
                      marginTop: screenHeight - 600 + "px",
                      marginRight: "1.5rem",
                      width: "100%",
                    }}
                  >
                    <Col onClick={() => navigate("/UserInfo?tab=1")}>
                      <span
                        style={{
                          display: "inline-flex",
                          color: "white",
                          lineHeight: "40px",
                          fontSize: "16px",
                          fontWeight: "325",
                          fontFamily: "YekanBakhVF",
                          cursor: "pointer",
                        }}
                      >
                        <span style={{ marginLeft: "5px" }}>
                          <UserWhiteIcon />
                        </span>
                        پروفایل فردی
                      </span>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "1rem", marginRight: "1.5rem" }}>
                    <Col onClick={() => navigate("/CompanyInfo?tab=1")}>
                      <span
                        style={{
                          display: "inline-flex",
                          color: "white",
                          lineHeight: "40px",
                          fontSize: "16px",
                          fontWeight: "325",
                          fontFamily: "YekanBakhVF",
                          cursor: "pointer",
                        }}
                      >
                        <span style={{ marginLeft: "5px" }}>
                          <BuildingWhiteIcon />
                        </span>
                        پروفایل فروشگاه
                      </span>
                    </Col>
                  </Row>
                </ConfigProvider>
              </Sider>
              <Content
                style={{
                  position: "fixed",
                  paddingTop: "10px",
                  marginTop: "165px",
                  marginRight: "220px",
                  paddingLeft: "10px",
                  height: "100%",
                  width: pageWidth - 230,
                  backgroundColor: "white",
                  overflow: "scroll",
                  scrollbarWidth: "none",
                }}
              >
                <Outlet />
              </Content>
            </div>
          </div>
        </>
      ) : (
        <>
          <Button
            type="primary"
            shape="circle"
            icon={<PlusOutlined />}
            size="large"
            className="floating-button"
          />
          <Tabs
            defaultActiveKey="2"
            tabPosition="bottom"
            style={{ height: "100vh" }}
            className="custom-tabs My"
          >
            <TabPane
              disabled
              className="fiii"
              tab={
                <div className="first ">
                  <span style={{ width: "40px", height: "40px" }}>
                    <DashboardIcon />
                  </span>
                  <span
                    style={{
                      width: "56px",
                      height: "18px",
                      lineHeight: "21.6px",
                      fontSize: "12px",
                      fontWeight: "450",
                      fontFamily: "YekanBakhVF",
                    }}
                  >
                    داشبورد
                  </span>
                </div>
              }
              key="1"
            >
              <div style={{ height: "92vh", overflow: "scroll" }}>
                <Outlet />
              </div>
            </TabPane>
            <TabPane
              tab={
                <>
                  <span style={{ width: "40px", height: "40px" }}>
                    <NoticesIcon />
                  </span>
                  <span
                    style={{
                      width: "56px",
                      height: "18px",
                      lineHeight: "21.6px",
                      fontSize: "12px",
                      fontWeight: "450",
                      fontFamily: "YekanBakhVF",
                    }}
                  >
                    آگهی
                  </span>
                </>
              }
              key="2"
            >
              <div style={{ height: "92vh", overflow: "scroll" }}>
                <Outlet />
              </div>
            </TabPane>
            <TabPane
              disabled
              style={{ visibility: "hidden", color: "transparent" }}
              tab={
                <>
                  <span style={{ width: "40px", height: "40px" }}></span>
                  <span
                    style={{
                      color: "transparent",
                      width: "56px",
                      height: "18px",
                      lineHeight: "21.6px",
                      fontSize: "12px",
                      fontWeight: "450",
                      fontFamily: "YekanBakhVF",
                    }}
                  >
                    داشبورد
                  </span>
                </>
              }
              key="3"
            >
              <div style={{ height: "92vh", overflow: "scroll" }}></div>
            </TabPane>
            <TabPane
              disabled
              tab={
                <>
                  <span style={{ width: "40px", height: "40px" }}>
                    <ProfileIcon />
                  </span>
                  <span
                    style={{
                      width: "56px",
                      height: "18px",
                      lineHeight: "21.6px",
                      fontSize: "12px",
                      fontWeight: "450",
                      fontFamily: "YekanBakhVF",
                    }}
                  >
                    پروفایل
                  </span>
                </>
              }
              key="4"
            >
              <div style={{ height: "92vh", overflow: "scroll" }}></div>
            </TabPane>
            <TabPane
              disabled
              tab={
                <>
                  <span style={{ width: "40px", height: "40px" }}>
                    <ChatIcon />
                  </span>
                  <span
                    style={{
                      width: "56px",
                      height: "18px",
                      lineHeight: "21.6px",
                      fontSize: "12px",
                      fontWeight: "450",
                      fontFamily: "YekanBakhVF",
                    }}
                  >
                    گفتگو
                  </span>
                </>
              }
              key="5"
            >
              <div style={{ height: "92vh", overflow: "scroll" }}></div>
            </TabPane>
          </Tabs>
        </>
      )}
    </>
  );
}
export default App;
